let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4a4w6")).then(() => parcelRequire('hotVs'));